import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8000";
// export const baseURL = "https://demo-backend.insignio.tech";
// export const baseURL = "https://sd-backend.insignio.tech";
// export const baseURL = "https://test-backend.gestcorretor.com";

export const baseURL = (() => {
  const { hostname } = window.location;

  if (hostname === "localhost") {
    return "http://localhost:8000"; // Local development API
  } else if (hostname === "dk.gestcorretor.com") {
    return "https://dk-backend.gestcorretor.com"; //  API
  } else if (hostname === "vz.gestcorretor.com") {
    return "https://vz-backend.gestcorretor.com"; // Production API
  } else if (hostname === "total.gestcorretor.com") {
    return "https://total-backend.gestcorretor.com"; // Production API
  } else if (hostname === "bilcos.gestcorretor.com") {
    return "https://bilcos-backend.gestcorretor.com"; // Production API
  }else if (hostname === "equinox.gestcorretor.com") {
    return "https://equinox-backend.gestcorretor.com"; // Production API
  }else if (hostname === "comcapital.gestcorretor.com") {
    return "https://comcapital-backend.gestcorretor.com"; // Production API
  }else if (hostname === "sdbrokers.gestcorretor.com") {
    return "https://sdbrokers-backend.gestcorretor.com"; // Production API
  }else if (hostname === "royalbrokers.gestcorretor.com") {
    return "https://royalbrokers-backend.gestcorretor.com"; // Production API
  }else if (hostname === "test.gestcorretor.com") {
    return "https://test-backend.gestcorretor.com"; // Production API
  }else if (hostname === "siglonet.gestcorretor.com") {
    return "https://siglonet-backend.gestcorretor.com"; // Production API
  }
  else {
    throw new Error("Unknown domain! Cannot set API baseURL.");
  }
})();

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
